// services/sanityImage.ts
import imageUrlBuilder from '@sanity/image-url'
import { sanityClient } from './SanityClient'

const builder = imageUrlBuilder(sanityClient)

export function urlFor(source: any) {
  return builder.image(source)
}
